// import React, { useLayoutEffect, useRef, useMemo } from "react";
// import * as am4core from "@amcharts/amcharts4/core";
// import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// am4core.useTheme(am4themes_animated);

// const PRODUCTS = ["HBB", "Baqati", "Hayyak", "Upgrade"];

// const TargetPerPlanChart = ({ premiumData, standardData }) => {
//   const chartRef = useRef(null);

//   // 🔥 Transform API data (same structure as your service)
//   const chartData = useMemo(() => {
//     if (!premiumData && !standardData) return [];

//     return PRODUCTS.map((product) => ({
//       product,
//       premiumTarget: premiumData?.[product]?.target ?? 0,
//       premiumSales: premiumData?.[product]?.sales_count ?? 0,
//       premiumPct: premiumData?.[product]?.achieved_percentage ?? 0,

//       standardTarget: standardData?.[product]?.target ?? 0,
//       standardSales: standardData?.[product]?.sales_count ?? 0,
//       standardPct: standardData?.[product]?.achieved_percentage ?? 0,
//     }));
//   }, [premiumData, standardData]);

//   useLayoutEffect(() => {
//     if (!chartData.length) return;

//     const chart = am4core.create("targetPerPlanChartDiv", am4charts.XYChart);
//     chartRef.current = chart;
//     chart.data = chartData;

//     // X Axis
//     const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
//     categoryAxis.dataFields.category = "product";
//     categoryAxis.renderer.cellStartLocation = 0.2;
//     categoryAxis.renderer.cellEndLocation = 0.8;

//     // Y Axis
//     const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
//     valueAxis.min = 0;
//     valueAxis.extraMax = 0.25;
//     valueAxis.numberFormatter.numberFormat = "#,###";

//     // SALES (Columns + % label)
//     const createColumnSeries = (field, pctField, name, color) => {
//       const series = chart.series.push(new am4charts.ColumnSeries());
//       series.dataFields.valueY = field;
//       series.dataFields.categoryX = "product";
//       series.name = name;

//       series.columns.template.fill = am4core.color(color);
//       series.columns.template.stroke = am4core.color(color);
//       series.columns.template.width = am4core.percent(55);
//       series.clustered = true;

//       series.tooltipText = "{name}: {valueY.formatNumber('#,###')}";

//       // % Label
//       const labelBullet = series.bullets.push(new am4charts.LabelBullet());
//       labelBullet.label.verticalCenter = "bottom";
//       labelBullet.label.dy = -10;
//       labelBullet.label.fontSize = 12;
//       labelBullet.label.fontWeight = "700";

//       labelBullet.label.adapter.add("text", (text, target) => {
//         const val = target.dataItem?.dataContext?.[pctField] ?? 0;
//         return val > 0 ? `${val}%` : "";
//       });

//       labelBullet.label.adapter.add("fill", (fill, target) => {
//         const val = target.dataItem?.dataContext?.[pctField] ?? 0;

//         if (val >= 100) return am4core.color("#2ecc71");
//         if (val >= 80) return am4core.color("#f39c12");
//         return am4core.color("#5B9BD5");
//       });

//       return series;
//     };

//     // TARGET (Line)
//     const createLineSeries = (field, name, color) => {
//       const series = chart.series.push(new am4charts.LineSeries());
//       series.dataFields.valueY = field;
//       series.dataFields.categoryX = "product";
//       series.name = name;

//       series.stroke = am4core.color(color);
//       series.strokeWidth = 3;
//       series.tensionX = 1;
//       series.fillOpacity = 0;
//       series.zIndex = 10;

//       const bullet = series.bullets.push(new am4charts.CircleBullet());
//       bullet.circle.radius = 4;
//       bullet.circle.fill = am4core.color("#fff");
//       bullet.circle.strokeWidth = 2;
//       bullet.circle.stroke = am4core.color(color);

//       series.tooltipText = "{name}: {valueY.formatNumber('#,###')}";

//       return series;
//     };

//     // Premium
//     createLineSeries("premiumTarget", "Premium Target", "#5B9BD5");
//     createColumnSeries(
//       "premiumSales",
//       "premiumPct",
//       "Premium Sales",
//       "#7DB8E8",
//     );

//     // Standard
//     createLineSeries("standardTarget", "Standard Target", "#9B8EC4");
//     createColumnSeries(
//       "standardSales",
//       "standardPct",
//       "Standard Sales",
//       "#F4A460",
//     );

//     chart.legend = new am4charts.Legend();
//     chart.legend.position = "bottom";

//     chart.cursor = new am4charts.XYCursor();
//     chart.cursor.lineY.disabled = true;
//     chart.cursor.lineX.disabled = true;
//     chart.cursor.behavior = "none";

//     return () => {
//       chart.dispose();
//     };
//   }, [chartData]);

//   if (!chartData.length) return null;

//   return (
//     <div style={{ width: "100%" }}>
//       <div id="targetPerPlanChartDiv" style={{ width: "100%", height: 440 }} />
//     </div>
//   );
// };

// export default TargetPerPlanChart;
import React, { useMemo } from "react";

const PRODUCTS = ["Hayyak", "Baqati", "HBB", "Upgrade"];

const ArcGauge = ({ pct = 0 }) => {
  const color = pct >= 90 ? "#f5a623" : pct >= 80 ? "#f5a623" : "#e05c5c";

  const R = 22;
  const cx = 30;
  const cy = 30;

  const toRad = (deg) => (deg * Math.PI) / 180;

  const arcPath = (from, to) => {
    const x1 = cx + R * Math.cos(toRad(from));
    const y1 = cy + R * Math.sin(toRad(from));
    const x2 = cx + R * Math.cos(toRad(to));
    const y2 = cy + R * Math.sin(toRad(to));
    const largeArc = to - from > 180 ? 1 : 0;
    return `M ${x1} ${y1} A ${R} ${R} 0 ${largeArc} 1 ${x2} ${y2}`;
  };

  const fillAngle = -180 + (Math.min(pct, 100) / 100) * 180;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <svg width={60} height={34} viewBox="0 0 60 34">
        <path
          d={arcPath(-180, 0)}
          fill="none"
          stroke="#e8e8e8"
          strokeWidth={5}
          strokeLinecap="round"
        />
        {pct > 0 && (
          <path
            d={arcPath(-180, fillAngle)}
            fill="none"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
          />
        )}
      </svg>
      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: color,
          background: pct >= 80 ? "#fff8ec" : "#fff0f0",
          borderRadius: 6,
          padding: "1px 8px",
          marginTop: -6,
        }}
      >
        {pct}%
      </span>
    </div>
  );
};

const TargetPerPlanChart = ({ premiumData, standardData }) => {
  const rows = useMemo(() => {
    return PRODUCTS.map((product) => ({
      product,
      premiumSales: premiumData?.[product]?.sales_count ?? 0,
      premiumTarget: premiumData?.[product]?.target ?? 0,
      premiumPct: premiumData?.[product]?.achieved_percentage ?? 0,
      standardSales: standardData?.[product]?.sales_count ?? 0,
      standardTarget: standardData?.[product]?.target ?? 0,
      standardPct: standardData?.[product]?.achieved_percentage ?? 0,
    }));
  }, [premiumData, standardData]);

  if (!premiumData && !standardData) return null;

  const BLUE = "#4a90d9";
  const ORANGE = "#e07840";

  const numStyle = (isPremium) => ({
    fontSize: 15,
    fontWeight: 600,
    color: isPremium ? BLUE : ORANGE,
    textAlign: "center",
    padding: "14px 10px",
    borderLeft: `3px solid ${isPremium ? BLUE : ORANGE}`,
  });

  const subHeaderBase = {
    fontSize: 11,
    fontWeight: 600,
    color: "#999",
    letterSpacing: "0.08em",
    textAlign: "center",
    padding: "8px 10px",
    borderBottom: "1px solid #eee",
  };

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        background: "#f7f8fc",
        borderRadius: 16,
        padding: "28px 24px",
      }}
    >
      <div style={{ marginBottom: 20 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "#aaa",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          Staff Performance
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, color: "#1a1a2e" }}>
          Target vs Achievement
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  width: "16%",
                  padding: "16px 20px",
                  textAlign: "left",
                  fontSize: 11,
                  fontWeight: 600,
                  color: "#bbb",
                  letterSpacing: "0.1em",
                  background: "#fafafa",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                SERVICE
              </th>
              <th
                colSpan={3}
                style={{
                  background: "#eef4fd",
                  borderBottom: "1px solid #f0f0f0",
                  borderLeft: `3px solid ${BLUE}`,
                  padding: "14px 10px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    fontSize: 13,
                    fontWeight: 700,
                    color: BLUE,
                    letterSpacing: "0.08em",
                  }}
                >
                  <span
                    style={{
                      width: 9,
                      height: 9,
                      borderRadius: "50%",
                      background: BLUE,
                      display: "inline-block",
                    }}
                  />
                  PREMIUM
                </div>
              </th>
              <th
                colSpan={3}
                style={{
                  background: "#fff5ee",
                  borderBottom: "1px solid #f0f0f0",
                  borderLeft: `3px solid ${ORANGE}`,
                  padding: "14px 10px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    fontSize: 13,
                    fontWeight: 700,
                    color: ORANGE,
                    letterSpacing: "0.08em",
                  }}
                >
                  <span
                    style={{
                      width: 9,
                      height: 9,
                      borderRadius: "50%",
                      background: ORANGE,
                      display: "inline-block",
                    }}
                  />
                  STANDARD
                </div>
              </th>
            </tr>
            <tr style={{ background: "#fafafa" }}>
              <th style={{ padding: "8px 20px" }} />
              <th style={{ ...subHeaderBase, borderLeft: `3px solid ${BLUE}` }}>
                SALES
              </th>
              <th style={subHeaderBase}>TARGET</th>
              <th style={subHeaderBase}>ACHIEVEMENT</th>
              <th
                style={{ ...subHeaderBase, borderLeft: `3px solid ${ORANGE}` }}
              >
                SALES
              </th>
              <th style={subHeaderBase}>TARGET</th>
              <th style={subHeaderBase}>ACHIEVEMENT</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={row.product}
                style={{
                  borderBottom:
                    i < rows.length - 1 ? "1px solid #f3f3f3" : "none",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#fafbff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              >
                <td
                  style={{
                    padding: "18px 20px",
                    fontWeight: 700,
                    fontSize: 15,
                    color: "#222",
                  }}
                >
                  {row.product}
                </td>
                <td style={numStyle(true)}>
                  {row.premiumSales.toLocaleString()}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: "14px 10px",
                    fontSize: 15,
                    color: "#555",
                  }}
                >
                  {row.premiumTarget.toLocaleString()}
                </td>
                <td style={{ textAlign: "center", padding: "10px" }}>
                  <ArcGauge pct={row.premiumPct} />
                </td>
                <td style={numStyle(false)}>
                  {row.standardSales.toLocaleString()}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: "14px 10px",
                    fontSize: 15,
                    color: "#555",
                  }}
                >
                  {row.standardTarget.toLocaleString()}
                </td>
                <td style={{ textAlign: "center", padding: "10px" }}>
                  <ArcGauge pct={row.standardPct} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TargetPerPlanChart;
